import React, { useContext, useEffect, useState } from "react";
import {
    ArchiveTick,
    Bill,
    Chart,
    Chart1,
    Check,
    Clipboard,
    Clock,
    DocumentText,
    DocumentText1,
    Gallery,
    MenuBoard,
    Message,
    Messages,
    Profile2User,
    Setting3,
    Video,
    VideoTime,
    Watch,
    Calendar,
    ClipboardText,
    StatusUp,
    Element4,
    ArrowCircleLeft,
    ArrangeVertical,
    Star
} from "iconsax-react";

//CONTEXT
import axios from "axios";
import { LuHeartHandshake } from "react-icons/lu";

import { GlobalContext } from "../app/providers/GlobalState";

import DropdownEstabelecimentos from "./Componentes/DropdownEstabelecimentos";
import DropdownPerfis from "./Componentes/DropdownPerfis";
import NomeNumeroUsuario from "./Componentes/NomeNumeroUsuario";
import InitialsAvatar from "../shared/components/InitialsAvatar";
import BotaoOpcao from "./Componentes/BotaoOpcao";
import BotaoOpcaoPrev from "./Componentes/BotaoOpcaoPrev";
import BotaoOpcaoIcon from "./Componentes/BotaoOpcaoIcon";
import BotaoOpcaoIconPP from "./Componentes/BotaoOpcaoIconPP";
import BotaoTurma from "./Componentes/BotaoTurma";

import { config, turmas, gerais, drive, play } from "../assets/menu";

export default function UserInfo() {
    const globalContext = useContext(GlobalContext);

    const [perfis, setPerfis] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const acessoEnsinoEspecial = [33, 37]; // IDs das entidades com acesso ao ensino especial

    const utilizadorInfo = {
        nome: globalContext.nome_utilizador,
        numero: globalContext.numero_utilizador
    };

    const onChangeEstabelecimento = estabelecimento => {
        localStorage.setItem("escola_selecionada", JSON.stringify(estabelecimento));
        localStorage.removeItem("perfil_selecionado");

        globalContext.atualizarState({
            estabelecimento,
            filtroEstabelecimentosUtilizado: true
        });

        carregarPerfis(estabelecimento.id);
    };

    const onChangePerfil = perfil => {
        localStorage.setItem("perfil_selecionado", JSON.stringify(perfil));

        globalContext.atualizarState({ perfil });

        carregarAcessos(perfil.id);

        globalContext.atualizarState({
            mostrarOptConfiguracoes: false,
            mostrarOptPaginasPublicas: false
        });
    };

    const carregarPerfis = entidadeId => {
        axios
            .get("/api/navbar/listar-perfis-utilizador", {
                params: { entidadeId }
            })
            .then(response => {
                setPerfis(response.data);

                const perfil = localStorage.getItem("perfil_selecionado")
                    ? JSON.parse(localStorage.getItem("perfil_selecionado"))
                    : response.data.find(x => x.principal) || response.data[0];

                localStorage.setItem("perfil_selecionado", JSON.stringify(perfil));

                globalContext.atualizarState({ perfil });
                globalContext.atualizarState({ perfis: response.data });

                carregarAcessos(perfil.id);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    setRedirect(true);
                }
            });
    };

    const turmasFavoritas = cursoid => {
        axios({
            method: "get",
            url: "/api/gerir-turma/turmas-favoritas",
            params: {
                perfilId: globalContext.perfil?.id
            }
        })
            .then(response => {
                globalContext.atualizarState({
                    favoritos: response.data
                });
            })
            .catch(error => {});
    };

    const carregarAcessos = perfilId => {
        axios
            .get("/api/permissoes/carregar-acessos", { params: { perfilId } })
            .then(response => {
                globalContext.atualizarState({
                    acessos: response.data,
                    utilizadorCarregado: true
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    setRedirect(true);
                }
            });
    };

    const carregarUtilizadorInfo = () => {
        axios({
            method: "get",
            url: "/api/navbar/dados-utilizador",
            timeout: 60 * 10 * 1000 // 10 minutos
        })
            .then(response => {
                const dados = response.data;

                globalContext.atualizarState({
                    id_utilizador: dados.id,
                    foto_utilizador: dados.foto,
                    avatar_utilizador: dados.avatar,
                    nome_utilizador: dados.nome_completo,
                    numero_utilizador: dados.numero,
                    sexo_utilizador: dados.sexo,
                    estabelecimento: dados.estabelecimento,
                    perfil: dados.perfil
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    setRedirect(true);
                    setRedirectLink("/login");
                } else {
                    console.error("Erro ao carregar dados do utilizador:", error);
                }
            });
    };

    const carregarEstabelecimentos = () => {
        axios
            .get("/api/navbar/listar-organismos-utilizador")
            .then(response => {
                const dadosEstabelecimentos = response.data;

                setEstabelecimentos(dadosEstabelecimentos);

                globalContext.atualizarState({
                    estabelecimentos: dadosEstabelecimentos
                });

                const estabelecimentoSelecionado = localStorage.getItem("escola_selecionada")
                    ? JSON.parse(localStorage.getItem("escola_selecionada"))
                    : dadosEstabelecimentos.find(x => x.principal) || dadosEstabelecimentos[0];

                localStorage.setItem("escola_selecionada", JSON.stringify(estabelecimentoSelecionado));

                globalContext.atualizarState({ estabelecimento: estabelecimentoSelecionado });

                carregarPerfis(estabelecimentoSelecionado.id);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    setRedirect(true);
                }
            });
    };

    useEffect(() => {
        sessionStorage.clear();

        setPerfis([]);

        if (!globalContext.utilizadorCarregado) {
            carregarUtilizadorInfo();
            carregarEstabelecimentos();
        } else {
            setEstabelecimentos(globalContext.estabelecimentos);
            setPerfis(globalContext.perfis);
        }
    }, []);

    useEffect(() => {
        sessionStorage.clear();
        if (globalContext.perfil?.id === 6) turmasFavoritas();
    }, [globalContext.perfil]);

    const buildMenu = () => {
        if (globalContext.perfil?.nome === "Professor") {
            return (
                <>
                    <BotaoOpcao link="utilizador-turmas" imagem={turmas} nome="Todas as Turmas" estilo="icons-opcoes turmas" />
                    {acessoEnsinoEspecial.includes(parseInt(localStorage.getItem("entidade_id"))) && (
                        <BotaoOpcaoIcon
                            link="utilizador-turmas-ensino-especial"
                            icon={<LuHeartHandshake />}
                            nome="Educação Especial"
                            estilo="icons-opcoes icon-ensino-especial"
                        />
                    )}
                    <BotaoOpcao link="utilizador-dados-gerais" imagem={gerais} nome="Dados Gerais" estilo="icons-opcoes dados-gerais" />
                    <BotaoOpcao imagem={drive} nome="Drive" estilo="icons-opcoes drive" link="utilizador-drive" />
                    <BotaoOpcao imagem={play} nome="Stepmeet" estilo="icons-opcoes stepmeet" link="/gestao-videoconferencias" />
                    <BotaoOpcao imagem={config} nome="Configurações" estilo="icons-opcoes configuracoes" link="/user-configuracoes" />
                </>
            );
        }

        if (globalContext.perfil?.nome === "Coordenador") {
            return (
                <>
                    <BotaoOpcao link="utilizador-turmas" imagem={turmas} nome="Todas as Turmas" estilo="icons-opcoes turmas" />
                    {acessoEnsinoEspecial.includes(parseInt(localStorage.getItem("entidade_id"))) && (
                        <BotaoOpcaoIcon
                            link="utilizador-turmas-ensino-especial"
                            icon={<LuHeartHandshake />}
                            nome="Educação Especial"
                            estilo="icons-opcoes icon-ensino-especial"
                        />
                    )}
                    <BotaoOpcao link="utilizador-dados-gerais" imagem={gerais} nome="Dados Gerais" estilo="icons-opcoes dados-gerais" />
                    {(localStorage.getItem("entidade_id") === "33" || localStorage.getItem("entidade_id") === "37") && (
                        <BotaoOpcaoIcon
                            icon={<StatusUp size="34" color="#F13F07" />}
                            nome="Dashboard"
                            estilo="icons-opcoes dashboard-icon"
                            externo
                            link="https://dashboard.stepforma.app/sso"
                        />
                    )}
                    <BotaoOpcao imagem={drive} nome="Drive" estilo="icons-opcoes drive" link="utilizador-drive" />
                    <BotaoOpcao imagem={play} nome="Stepmeet" estilo="icons-opcoes stepmeet" link="/gestao-videoconferencias" />
                    <BotaoOpcao imagem={config} nome="Configurações" estilo="icons-opcoes configuracoes" link="/user-configuracoes" />
                    <BotaoOpcaoIcon
                        link="#"
                        icon={<Element4 size="34" color="#51A100" />}
                        nome="Página Pública"
                        estilo="icons-opcoes paginas-publicas"
                        onClick={() => globalContext.atualizarState({ mostrarOptPaginasPublicas: true })}
                    />
                    <BotaoOpcaoIcon
                        link="gestao-utilizadores-todos"
                        icon={<Profile2User size="32" color="#2121F5" />}
                        nome="Usuários"
                        estilo="icons-opcoes usuarios"
                        onClick={() =>
                            globalContext.atualizarState({
                                pesquisaInfo: null
                            })
                        }
                    />
                </>
            );
        }

        if (globalContext.perfil?.nome === "Administrativo" || globalContext.perfil?.nome === "Diretor") {
            return (
                <>
                    <BotaoOpcao
                        link="gestao-turmas"
                        imagem={turmas}
                        nome="Todas as Turmas"
                        estilo="icons-opcoes turmas"
                        onClick={() => {
                            localStorage.removeItem("opcao_voltar");
                            localStorage.removeItem("temp_opcao_voltar");
                            localStorage.removeItem("filtroEdicao");
                            localStorage.removeItem("filtroCategoria");
                        }}
                    />
                    {parseInt(localStorage.getItem("entidade_id")) === 33 && (
                        <BotaoOpcaoIcon
                            link="gestao-ensino-especial"
                            icon={<LuHeartHandshake />}
                            nome="Educação Especial"
                            estilo="icons-opcoes icon-ensino-especial"
                            onClick={() => {
                                localStorage.removeItem("opcao_voltar");
                                localStorage.removeItem("temp_opcao_voltar");
                                localStorage.removeItem("filtroEdicao");
                                localStorage.removeItem("filtroCategoria");
                            }}
                        />
                    )}
                    <BotaoOpcao link="utilizador-dados-gerais" imagem={gerais} nome="Dados Gerais" estilo="icons-opcoes dados-gerais" />
                    <BotaoOpcao imagem={play} nome="Stepmeet" estilo="icons-opcoes stepmeet" link="/gestao-videoconferencias" />
                    <BotaoOpcaoIcon
                        link="#"
                        icon={<Element4 size="34" color="#51A100" />}
                        nome="Página Pública"
                        estilo="icons-opcoes paginas-publicas"
                        onClick={() => globalContext.atualizarState({ mostrarOptPaginasPublicas: true })}
                    />
                    {(localStorage.getItem("entidade_id") === "33" || localStorage.getItem("entidade_id") === "37") && (
                        <BotaoOpcaoIcon
                            icon={<StatusUp size="34" color="#F13F07" />}
                            nome="Dashboard"
                            estilo="icons-opcoes dashboard-icon"
                            externo
                            link="https://dashboard.stepforma.app/sso"
                        />
                    )}
                    <BotaoOpcaoIcon
                        link="gestao-utilizadores-todos"
                        icon={<Profile2User size="32" color="#2121F5" />}
                        nome="Usuários"
                        estilo="icons-opcoes usuarios"
                        onClick={() =>
                            globalContext.atualizarState({
                                pesquisaInfo: null
                            })
                        }
                    />
                    {globalContext.perfil?.nome === "Administrativo" && (
                        <BotaoOpcaoIcon
                            icon={<ArrangeVertical size="32" color="#000000" />}
                            nome="Transferências"
                            estilo="icons-opcoes menu-conf"
                            link="/transferencias"
                        />
                    )}
                </>
            );
        }

        if (globalContext.perfil?.nome === "Suporte") {
            return (
                <>
                    <BotaoOpcaoPrev
                        link="gestao-turmas"
                        imagem={turmas}
                        nome="Todas as Turmas"
                        estilo="icons-opcoes turmas"
                        onClick={() => {
                            localStorage.removeItem("opcao_voltar");
                            localStorage.removeItem("temp_opcao_voltar");
                            localStorage.removeItem("filtroEdicao");
                            localStorage.removeItem("filtroCategoria");
                        }}
                    />
                    {acessoEnsinoEspecial.includes(parseInt(localStorage.getItem("entidade_id"))) && (
                        <BotaoOpcaoIcon
                            link="gestao-ensino-especial"
                            icon={<LuHeartHandshake />}
                            nome="Educação Especial"
                            estilo="icons-opcoes icon-ensino-especial"
                            onClick={() => {
                                localStorage.removeItem("opcao_voltar");
                                localStorage.removeItem("temp_opcao_voltar");
                                localStorage.removeItem("filtroEdicao");
                                localStorage.removeItem("filtroCategoria");
                            }}
                        />
                    )}
                    <BotaoOpcaoIcon
                        link="#"
                        icon={<Element4 size="34" color="#51A100" />}
                        nome="Página Pública"
                        estilo="icons-opcoes paginas-publicas"
                        onClick={() => globalContext.atualizarState({ mostrarOptPaginasPublicas: true })}
                    />
                    <BotaoOpcao imagem={play} nome="Stepmeet" estilo="icons-opcoes stepmeet" link="/gestao-videoconferencias" />
                    <BotaoOpcaoIcon
                        icon={<StatusUp size="34" color="#F13F07" />}
                        nome="Dashboard"
                        estilo="icons-opcoes dashboard-icon"
                        externo
                        link="https://dashboard.stepforma.app/sso"
                    />
                    <BotaoOpcao
                        link="#"
                        imagem={config}
                        nome="Configurações"
                        estilo="icons-opcoes configuracoes"
                        onClick={() => globalContext.atualizarState({ mostrarOptConfiguracoes: true })}
                    />

                    <BotaoOpcaoIcon
                        link="gestao-utilizadores-todos"
                        icon={<Profile2User size="32" color="#2121F5" />}
                        nome="Usuários"
                        estilo="icons-opcoes usuarios"
                        onClick={() =>
                            globalContext.atualizarState({
                                pesquisaInfo: null
                            })
                        }
                    />
                    <BotaoOpcaoIcon
                        icon={<ArrangeVertical size="32" color="#000000" />}
                        nome="Transferências"
                        estilo="icons-opcoes menu-conf"
                        link="/transferencias"
                    />
                </>
            );
        }

        if (globalContext.perfil?.nome === "Gestor" || globalContext.perfil?.nome === "SEMEI") {
            return (
                <>
                    <BotaoOpcaoPrev
                        link="gestao-turmas"
                        imagem={turmas}
                        nome="Todas as Turmas"
                        estilo="icons-opcoes turmas"
                        onClick={() => {
                            localStorage.removeItem("opcao_voltar");
                            localStorage.removeItem("temp_opcao_voltar");
                            localStorage.removeItem("filtroEdicao");
                            localStorage.removeItem("filtroCategoria");
                        }}
                    />
                    {parseInt(localStorage.getItem("entidade_id")) === 37 && (
                        <BotaoOpcaoIcon
                            link="gestao-ensino-especial"
                            icon={<LuHeartHandshake />}
                            nome="Educação Especial"
                            estilo="icons-opcoes icon-ensino-especial"
                            onClick={() => {
                                localStorage.removeItem("opcao_voltar");
                                localStorage.removeItem("temp_opcao_voltar");
                                localStorage.removeItem("filtroEdicao");
                                localStorage.removeItem("filtroCategoria");
                            }}
                        />
                    )}
                    <BotaoOpcao link="utilizador-dados-gerais" imagem={gerais} nome="Dados Gerais" estilo="icons-opcoes dados-gerais" />
                    <BotaoOpcaoIcon
                        link="#"
                        icon={<Element4 size="34" color="#51A100" />}
                        nome="Página Pública"
                        estilo="icons-opcoes paginas-publicas"
                        onClick={() => globalContext.atualizarState({ mostrarOptPaginasPublicas: true })}
                    />
                    <BotaoOpcao imagem={play} nome="Stepmeet" estilo="icons-opcoes stepmeet" link="/gestao-videoconferencias" />
                    <BotaoOpcaoIcon
                        icon={<StatusUp size="34" color="#F13F07" />}
                        nome="Dashboard"
                        estilo="icons-opcoes dashboard-icon"
                        externo
                        link="https://dashboard.stepforma.app/sso"
                    />
                    {localStorage.getItem("entidade_id") !== "33" && (
                        <BotaoOpcaoIcon
                            link="gestao-utilizadores-todos"
                            icon={<Profile2User size="32" color="#2121F5" />}
                            nome="Usuários"
                            estilo="icons-opcoes usuarios"
                            onClick={() =>
                                globalContext.atualizarState({
                                    pesquisaInfo: null
                                })
                            }
                        />
                    )}
                </>
            );
        }
    };

    const menuPrincipalComTurmas = (
        <div className="grid-container-opcoes">
            {globalContext.perfil?.id === 6 ? (
                <>
                    {globalContext.favoritos.length > 0 && (
                        <>
                            <div></div>
                            <div className="turmas-acessadas">Turmas mais acessadas:</div>
                        </>
                    )}

                    <div className="opcoes-user">{buildMenu()}</div>
                    <div className="grid-container-opt-turmas">
                        {globalContext.favoritos.length > 0 &&
                            globalContext.favoritos.map(turma => <BotaoTurma key={turma.id} turma={turma} />)}
                    </div>
                </>
            ) : (
                <>
                    <div className="opcoes-user">{buildMenu()}</div>
                </>
            )}
        </div>
    );

    const menuPaginasPublicas = () => {
        if (globalContext.perfil?.nome === "Suporte") {
            return (
                <div className="grid-conteiner-opcoes-menu">
                    <BotaoOpcaoIconPP
                        icon={<Chart size="32" color="#51A100" />}
                        nome="Categorias Notícias"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-categoria-noticias"
                    />
                    <BotaoOpcaoIconPP
                        icon={<Check size="32" color="#51A100" />}
                        nome="Carrossel"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-carrossel"
                    />
                    <BotaoOpcaoIconPP
                        icon={<Gallery size="32" color="#51A100" />}
                        nome="Galeria de fotos"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-fotos"
                    />

                    <BotaoOpcaoIconPP
                        icon={<DocumentText size="32" color="#51A100" />}
                        nome="Notícias"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-noticias"
                    />

                    <BotaoOpcaoIconPP
                        icon={<DocumentText1 size="32" color="#51A100" />}
                        nome="Páginas"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-paginas"
                    />

                    <BotaoOpcaoIconPP
                        icon={<Message size="32" color="#51A100" />}
                        nome="Comentários"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-comentario"
                    />
                    <BotaoOpcaoIconPP
                        icon={<Video size="32" color="#51A100" />}
                        nome="Vídeos"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-videos"
                    />
                    <BotaoOpcaoIconPP
                        icon={<Setting3 size="32" color="#51A100" />}
                        nome="Configurações"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-conta"
                    />
                    <BotaoOpcaoIconPP
                        icon={<Messages size="32" color="#51A100" />}
                        nome="FAQ"
                        estilo="icons-opcoes pag-pub-mobile paginas-publicas"
                        link="/gestao-faq"
                    />
                </div>
            );
        }

        if (globalContext.perfil?.nome === "Gestor" || globalContext.perfil?.nome === "SEMEI") {
            return (
                <div className="grid-conteiner-opcoes-menu">
                    <BotaoOpcaoIcon
                        icon={<Chart size="32" color="#51A100" />}
                        nome="Categorias Notícias"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-categoria-noticias"
                    />
                    {localStorage.getItem("entidade_id") !== "33" && (
                        <BotaoOpcaoIcon
                            icon={<Check size="32" color="#51A100" />}
                            nome="Carrosel"
                            estilo="icons-opcoes paginas-publicas"
                            link="/gestao-carrossel"
                        />
                    )}
                    <BotaoOpcaoIcon
                        icon={<Gallery size="32" color="#51A100" />}
                        nome="Galeria de fotos"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-fotos"
                    />
                    <BotaoOpcaoIcon
                        icon={<DocumentText size="32" color="#51A100" />}
                        nome="Notícias"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-noticias"
                    />
                    {localStorage.getItem("entidade_id") !== "33" && (
                        <>
                            <BotaoOpcaoIcon
                                icon={<DocumentText1 size="32" color="#51A100" />}
                                nome="Páginas"
                                estilo="icons-opcoes paginas-publicas"
                                link="/gestao-paginas"
                            />

                            <BotaoOpcaoIcon
                                icon={<Message size="32" color="#51A100" />}
                                nome="Comentários"
                                estilo="icons-opcoes paginas-publicas"
                                link="/gestao-comentario"
                            />
                        </>
                    )}
                    <BotaoOpcaoIcon
                        icon={<Video size="32" color="#51A100" />}
                        nome="Vídeos"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-videos"
                    />
                    {localStorage.getItem("entidade_id") !== "33" && (
                        <>
                            <BotaoOpcaoIcon
                                icon={<Setting3 size="32" color="#51A100" />}
                                nome="Configurações"
                                estilo="icons-opcoes paginas-publicas"
                                link="/gestao-conta"
                            />
                            <BotaoOpcaoIcon
                                icon={<Messages size="32" color="#51A100" />}
                                nome="FAQ"
                                estilo="icons-opcoes paginas-publicas"
                                link="/gestao-faq"
                            />
                            <BotaoOpcaoIcon
                                icon={<Clipboard size="32" color="#51A100" />}
                                nome="Estabelecimentos"
                                estilo="icons-opcoes paginas-publicas"
                                link="/gestao-unidades-organizacionais"
                            />
                        </>
                    )}
                </div>
            );
        }

        if (globalContext.perfil?.nome === "Administrativo" || globalContext.perfil?.nome === "Diretor") {
            return (
                <div className="grid-conteiner-opcoes-menu">
                    <BotaoOpcaoIcon
                        icon={<Chart size="32" color="#51A100" />}
                        nome="Categorias Notícias"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-categoria-noticias"
                    />
                    {localStorage.getItem("entidade_id") === "33" && (
                        <BotaoOpcaoIcon
                            icon={<Gallery size="32" color="#51A100" />}
                            nome="Galeria de fotos"
                            estilo="icons-opcoes paginas-publicas"
                            link="/gestao-fotos"
                        />
                    )}
                    <BotaoOpcaoIcon
                        icon={<DocumentText size="32" color="#51A100" />}
                        nome="Notícias"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-noticias"
                    />
                    {localStorage.getItem("entidade_id") === "33" && (
                        <BotaoOpcaoIcon
                            icon={<Video size="32" color="#51A100" />}
                            nome="Vídeos"
                            estilo="icons-opcoes paginas-publicas"
                            link="/gestao-videos"
                        />
                    )}
                </div>
            );
        }

        if (globalContext.perfil?.nome === "Coordenador") {
            return (
                <div className="grid-conteiner-opcoes-menu">
                    <BotaoOpcaoIcon
                        icon={<Chart size="32" color="#51A100" />}
                        nome="Categorias Notícias"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-categoria-noticias"
                    />
                    {localStorage.getItem("entidade_id") === "33" && (
                        <BotaoOpcaoIcon
                            icon={<Gallery size="32" color="#51A100" />}
                            nome="Galeria de fotos"
                            estilo="icons-opcoes paginas-publicas"
                            link="/gestao-fotos"
                        />
                    )}
                    <BotaoOpcaoIcon
                        icon={<DocumentText size="32" color="#51A100" />}
                        nome="Notícias"
                        estilo="icons-opcoes paginas-publicas"
                        link="/gestao-noticias"
                    />
                    {localStorage.getItem("entidade_id") === "33" && (
                        <BotaoOpcaoIcon
                            icon={<Video size="32" color="#51A100" />}
                            nome="Vídeos"
                            estilo="icons-opcoes paginas-publicas"
                            link="/gestao-videos"
                        />
                    )}
                </div>
            );
        }
    };

    const menuConfiguracoes = (
        <div className="grid-conteiner-opcoes-menu">
            <BotaoOpcaoIcon
                link="/gestao-templates-turmas"
                icon={<Bill size="32" color="#000000" />}
                nome="Planos de Estudos"
                estilo="icons-opcoes menu-conf"
            />
            <BotaoOpcaoIcon
                icon={<ClipboardText size="32" color="#000000" />}
                nome="Fichas"
                estilo="icons-opcoes menu-conf"
                link="/gestao-fichas"
            />
            <BotaoOpcaoIcon
                icon={<Chart1 size="32" color="#000000" />}
                nome="Níveis de ensino"
                estilo="icons-opcoes menu-conf"
                link="/gestao-turmas-categorias"
            />
            <BotaoOpcaoIcon
                icon={<ArchiveTick size="32" color="#000000" />}
                nome="Avaliação"
                estilo="icons-opcoes menu-conf"
                link="/gestao-diario"
            />

            <BotaoOpcaoIcon
                icon={<Calendar size="32" color="#000000" />}
                nome="Calendários"
                estilo="icons-opcoes menu-conf"
                link="/gestao-calendarios-escolares"
            />

            <BotaoOpcaoIcon
                icon={<VideoTime size="32" color="#000000" />}
                nome="Edições"
                estilo="icons-opcoes menu-conf"
                link="/gestao-turmas-edicoes"
            />

            <BotaoOpcaoIcon
                icon={<MenuBoard size="32" color="#000000" />}
                nome="Anos Letivos"
                estilo="icons-opcoes menu-conf"
                link="/gestao-turmas-anos-letivos"
            />
            <BotaoOpcaoIcon
                icon={<Watch size="32" color="#000000" />}
                nome="Turnos"
                estilo="icons-opcoes menu-conf"
                link="/gestao-turmas-turnos"
            />
            <BotaoOpcaoIcon
                icon={<Clock size="32" color="#000000" />}
                nome="Tipos de horas"
                estilo="icons-opcoes menu-conf"
                link="/gestao-turmas-tipo-horas"
            />
            <BotaoOpcaoIcon
                icon={<ArrangeVertical size="32" color="#000000" />}
                nome="Transferências"
                estilo="icons-opcoes menu-conf"
                link="/transferencias"
            />
            <BotaoOpcaoIconPP
                icon={<Clipboard size="32" color="#000000" />}
                nome="Estabelecimentos"
                estilo="icons-opcoes menu-conf"
                link="/gestao-unidades-organizacionais"
            />
            <BotaoOpcaoIconPP
                icon={<Star size="32" color="#000000" />}
                nome="Habilidades"
                estilo="icons-opcoes menu-conf"
                link="/configs/habilidades"
            />
        </div>
    );

    const shouldAddMargin = () => {
        if (globalContext.perfil?.id !== 6) return true;

        if (globalContext.perfil?.id === 6 && globalContext.favoritos.length === 0) return true;

        return false;
    };

    const builPage = () => {
        if (globalContext.mostrarOptPaginasPublicas) {
            return menuPaginasPublicas();
        }

        if (globalContext.mostrarOptConfiguracoes) {
            return menuConfiguracoes;
        }
        // Caso nenhuma condição seja verdadeira, retornar menuPrincipalComTurmas
        return menuPrincipalComTurmas;
    };

    return (
        <div className="details-page-prof-cord esconder-drop">
            <div className="hidden-mobile">
                <div className={`info-user `}>
                    <div className="dropdown-grupo">
                        <DropdownPerfis perfis={perfis} onPerfilChange={onChangePerfil}></DropdownPerfis>

                        <DropdownEstabelecimentos
                            onEstabelecimentoChange={onChangeEstabelecimento}
                            estabelecimentos={estabelecimentos}
                        ></DropdownEstabelecimentos>
                    </div>
                </div>
            </div>

            <div className="hidden-mobile">
                <div className="voltar-mobile">
                    {(globalContext.mostrarOptConfiguracoes || globalContext.mostrarOptPaginasPublicas) && (
                        <button
                            className="botao-voltar2"
                            onClick={() =>
                                globalContext.atualizarState({
                                    mostrarOptConfiguracoes: false,
                                    mostrarOptPaginasPublicas: false
                                })
                            }
                        >
                            <ArrowCircleLeft size="34" />
                        </button>
                    )}
                </div>
            </div>

            <div className="imagem-perfil">
                {globalContext.foto_utilizador ? (
                    <div className="container-img">
                        <img src={globalContext.foto_utilizador} />
                    </div>
                ) : (
                    utilizadorInfo?.nome !== "" && <InitialsAvatar name={utilizadorInfo.nome} />
                )}
            </div>

            <div className="corpo">
                <div className="hidden-desktop">
                    <div className={`info-user ${shouldAddMargin() ? "margin50" : ""}`}>
                        <NomeNumeroUsuario
                            nome={utilizadorInfo?.nome}
                            numero={utilizadorInfo?.numero}
                            mostraBotao={globalContext.mostrarOptPaginasPublicas || globalContext.mostrarOptConfiguracoes}
                            onClick={() => {
                                globalContext.atualizarState({
                                    mostrarOptConfiguracoes: false,
                                    mostrarOptPaginasPublicas: false
                                });
                            }}
                        ></NomeNumeroUsuario>
                        <div className="dropdown-grupo">
                            <DropdownEstabelecimentos
                                onEstabelecimentoChange={onChangeEstabelecimento}
                                estabelecimentos={estabelecimentos}
                            ></DropdownEstabelecimentos>
                            <DropdownPerfis perfis={perfis} onPerfilChange={onChangePerfil}></DropdownPerfis>
                        </div>
                    </div>
                </div>

                <div className="hidden-mobile">
                    <div className="info-user">
                        <NomeNumeroUsuario nome={utilizadorInfo?.nome} numero={utilizadorInfo?.numero}></NomeNumeroUsuario>
                    </div>
                </div>

                {builPage()}
            </div>
        </div>
    );
}
